var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"projectDetail"}},[(_vm.$store.state.device == 'mob')?_c('mProjectDetail'):_vm._e(),(_vm.$store.state.device == 'pc')?_c('pProjectDetail'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }